export interface IServerMappedSetting {
    Name: string;
    Value: string;
}

export enum Setting {
    installationId = 'InstallationId',
    activationId = 'ActivationId',
    timezone = 'Timezone.Iana',
    timezoneId = 'Abp.Timing.TimeZone',
    cookieExpireMinutes = 'Auth.CookieExpireMinutes',
    librariesUseSharedFeed = 'Deployment.Libraries.UseSharedFeed',
    librariesAllowTenantPublish = 'Deployment.Libraries.AllowTenantPublish',
    isWindowsAuthEnabled = 'WindowsAuth.Enabled',
    windowsAuthDomain = 'WindowsAuth.Domain',
    isCloudRPAInstanceEnabled = 'CloudRPA.Instance.Enabled',
    isMultipleDatabasesEnabled = 'MultiTenancy.MultipleDatabases.Enabled',
    customTitle = 'CustomTitle',
    currentCulture = 'CurrentCulture',
    isPackagesInternalDeployment = 'InternalDeployment',
    isLibrariesInternalDeployment = 'Deployment.Libraries.Internal',
    uploadQueuesMaxNumberOfItems = 'Upload.Queues.MaxNumberOfItems',
    monitoringSignalrUrl = 'Monitoring.Realtime.SignalrUrl',
    monitoringHealthStateRefreshInterval = 'Monitoring.Realtime.HealthStatePollingInterval',
    monitoringRefreshInterval = 'Monitoring.Realtime.PollingInterval',
    helpUrl = 'HelpUrl',
    analyticsBaseAddress = 'Insights.Portal.BaseUrl',
    mlPackagingInstructionsUrl = 'AiFabric.MLPackagingInstructionsUrl',
    legacyMode = 'License.LegacyMode',
    serviceUrl = 'License.ServiceURL',
    isMultipleCalendarsEnabled = 'MultipleNonWorkingLists.Enabled',
    isModernFolderSystemEnabled = 'Features.ModernFolders.Enabled',
}

export const STRING_SETTINGS: Readonly<string[]> = [
    Setting.installationId,
    Setting.activationId,
    Setting.timezone,
    Setting.timezoneId,
    Setting.windowsAuthDomain,
    Setting.customTitle,
    Setting.currentCulture,
    Setting.monitoringSignalrUrl,
    Setting.helpUrl,
    Setting.analyticsBaseAddress,
    Setting.mlPackagingInstructionsUrl,
    Setting.serviceUrl,
];

export type StringSettings =
    Setting.installationId |
    Setting.activationId |
    Setting.timezone |
    Setting.timezoneId |
    Setting.windowsAuthDomain |
    Setting.customTitle |
    Setting.currentCulture |
    Setting.monitoringSignalrUrl |
    Setting.helpUrl |
    Setting.analyticsBaseAddress |
    Setting.mlPackagingInstructionsUrl |
    Setting.serviceUrl;

export const BOOLEAN_SETTINGS = [
    Setting.librariesUseSharedFeed,
    Setting.librariesAllowTenantPublish,
    Setting.isWindowsAuthEnabled,
    Setting.isCloudRPAInstanceEnabled,
    Setting.isMultipleDatabasesEnabled,
    Setting.isPackagesInternalDeployment,
    Setting.isLibrariesInternalDeployment,
    Setting.isModernFolderSystemEnabled,
    Setting.legacyMode,
];

export type BooleanSettings =
    Setting.librariesUseSharedFeed |
    Setting.librariesAllowTenantPublish |
    Setting.isWindowsAuthEnabled |
    Setting.isCloudRPAInstanceEnabled |
    Setting.isMultipleDatabasesEnabled |
    Setting.isPackagesInternalDeployment |
    Setting.isLibrariesInternalDeployment |
    Setting.legacyMode |
    Setting.isMultipleCalendarsEnabled |
    Setting.isModernFolderSystemEnabled;

export const NUMERIC_SETTINGS = [
    Setting.cookieExpireMinutes,
    Setting.uploadQueuesMaxNumberOfItems,
    Setting.monitoringHealthStateRefreshInterval,
    Setting.monitoringRefreshInterval,
];

export type NumericSettings =
    Setting.cookieExpireMinutes |
    Setting.uploadQueuesMaxNumberOfItems |
    Setting.monitoringHealthStateRefreshInterval |
    Setting.monitoringRefreshInterval;
